<template>
  <div>
    <portal to="stats">
      <StatisticsHeader
        :fetchingLogs="fetchingLogs"
        :interns="interns"
        :internships="completeInterships"
        :selectedUsers.sync="selectedUsers"
        :statsData.sync="statsData"
        :resumeTables="resumeTables"
        :statComponents="statComponents"
        :userSpecialties="userSpecialties"
        :coordinatedUsers="coordinatedUsers"
        :dateFilter.sync="dateFilter"
        :showStats.sync="showStats"
      />
    </portal>

    <v-layout wrap align-center>
      <v-flex v-if="selectedLogbook || showStats">
        <v-btn
          v-if="selectedLogbook || showStats"
          @click="returnToDash()"
          outline
          color="primary"
          round
          ><h4 class="primary--text pl-1">Voltar</h4></v-btn
        >
      </v-flex>
      <v-flex v-if="interns">
        <v-select
          v-model="coordinatedUser"
          label="Interno"
          item-value="value"
          :items="coordinatedUsers"
          single-line
          class="px-2"
        >
          <template v-slot:prepend-inner>
            <Icon name="home-user" />
          </template>
          <template v-slot:selection="{ item }">
            {{ item.text }}
          </template>
          <template v-slot:item="{ item }">
            {{ item.text }}
          </template>
        </v-select>
      </v-flex>
      <v-flex>
        <div style="text-align: right">
          <v-btn
            @click="$root.$emit('statsdrawer', true)"
            outline
            color="primary"
            round
          >
            <h4 class="primary--text pl-1">Estatísticas</h4>
            <Icon size="24px" class="ml-2" name="filter" />
          </v-btn>
          <v-btn
            @click="$root.$emit('costumizerDrawer', true)"
            outline
            color="primary"
            round
          >
            <h4 class="primary--text pl-1">editar</h4>
            <Icon size="24px" class="ml-2" name="paint" />
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex d-flex xs12 md12>
        <v-card flat class="ma-2 pt-1 pb-1 card-rounded">
          <v-card-actions class="py-0">
            <v-toolbar dense flat class="transparent second-toolbar">
              <v-layout wrap row>
                <v-flex d-flex xs12 md6>
                  <v-select
                    @change="changeSpecialty"
                    class="thin-border"
                    v-model="selectedSpecialty"
                    :loading="fetchingLogs"
                    :items="specialtyItems"
                    hideDetails
                    single-line
                    solo
                    label="Especialidade"
                  />
                </v-flex>
              </v-layout>

              <v-btn-toggle class="transparent" mandatory v-model="datePeriod">
                <v-btn :value="userStartDate()" flat small> Total </v-btn>
                <v-btn class="ml-0" :value="13" flat small> Anual </v-btn>
                <v-btn class="ml-0" :value="7" flat small> 6 Meses </v-btn>
              </v-btn-toggle>
            </v-toolbar>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <StatsDashboard
      v-if="!showStats"
      :logs="filteredLogs"
      :selectedLogbook.sync="selectedLogbook"
      :datePeriod="datePeriod"
      :fetchingLogs="fetchingLogs"
      :resumeTables="resumeTables"
    />

    <v-layout wrap justify-center v-if="showStats">
      <v-card
        class="table-card mt-4"
        min-width="400px"
        style="border-radius: 10px"
        flat
      >
        <v-card-actions>
          <v-btn
            v-if="statsData.selectedDisplayMode === 'table'"
            @click="downloadTable"
            depressed
            small
            dark
            color="primary"
            round
            class="pl-1"
          >
            <v-avatar color="white" size="24" class="mr-1">
              <Icon class="mx-1" name="clipboard" size="24px" />
            </v-avatar>
            <span class="pl-1">Exportar tabela</span>
          </v-btn>
          <v-spacer />
          <v-btn
            @click="print('printArea')"
            depressed
            small
            dark
            color="primary"
            round
            class="pl-1"
          >
            <v-avatar color="white" size="24" class="mr-1">
              <v-progress-circular
                v-if="isDownloading"
                indeterminate
                color="primary"
                class="ma-1"
              />
              <Icon v-else class="mx-1" name="download" size="24px" />
            </v-avatar>
            <span class="pl-1">Exportar como imagem</span>
          </v-btn>
        </v-card-actions>

        <v-card-text class="pa-0">
          <div class="pa-3">
            <portal-target name="cardActions"> </portal-target>
          </div>

          <div style="overflow-x: auto">
            <div
              class="pa-3"
              style="background-color: #fff; width: 100%"
              id="printArea"
            >
              <h4
                class="font-weight-regular mb-2"
                v-if="statsTitle"
                v-text="statsTitle"
              />
              <!-- Data Components here !!! -->
              <PieChart
                v-if="statsData.selectedDisplayMode === 'pie'"
                :logs="filteredLogs"
                :statsData="statsData"
              />
              <BarChart
                v-if="statsData.selectedDisplayMode === 'bar'"
                :logs="filteredLogs"
                :statsData="statsData"
              />
              <template v-if="statsData.selectedDisplayMode === 'table'">
                <Icd10Table
                  v-if="
                    statsData.variables && statsData.variables.row1 && isICD10
                  "
                  :row1="statsData.variables.row1"
                  :logs="filteredLogs"
                />
                <Icd11Table
                  v-if="
                    statsData.variables && statsData.variables.row1 && isICD11
                  "
                  :row1="statsData.variables.row1"
                  :logs="filteredLogs"
                />
                <ConditionsTable
                  v-else-if="
                    statsData.variables &&
                    statsData.variables.row1 &&
                    statsData.variables.row1.condition &&
                    statsData.variables.row1.condition === true
                  "
                  :statsData="statsData"
                  :logs="filteredLogs"
                />
                <TreeTable
                  v-else-if="statsData.tableType === 'variables' && isTreeVars"
                  :logs="filteredLogs"
                  :statsData="statsData"
                />
                <Table2by2
                  v-else-if="statsData.tableType === 'variables' && !isICD10"
                  :logs="filteredLogs"
                  :selectedUsers="selectedUsers"
                  :coordinatedUsers="coordinatedUsers"
                  :statsData="statsData"
                />
                <AutonomyAndEtiologyBarChart
                  :logs="filteredLogs"
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable ===
                      'autonomyAndEtiologyBarChart'
                  "
                />
                <AutonomyTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable === 'resumeAutonomy'
                  "
                  :logs="filteredLogs"
                  :logbookType="statsData.logbookType"
                />
                <AnesthesiaDiagnoseTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable === 'resumeByDiagnose'
                  "
                  :logs="filteredLogs"
                  :logbookType="statsData.logbookType"
                />
                <AnesthesiaCombinedReportTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    (statsData.selectedResumeTable === 'resumeBySpecialty' ||
                      statsData.selectedResumeTable === 'resumeByInternship')
                  "
                  :logs="filteredLogs"
                  :logbookType="statsData.logbookType"
                  :selectedResume="statsData.selectedResumeTable"
                />
                <AnesthesiaAppointmentTable
                  v-else-if="
                    statsData.selectedResumeTable === 'resumeByAppointment'
                  "
                  :logs="filteredLogs"
                />
                <SurgeryGeneralReport
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable === 'resumeSurgeryGeral'
                  "
                  :logbookType="statsData.logbookType"
                  :logs="filteredLogs"
                />
                <AnatomicRegionDiagnosisProcedureTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable ===
                      'anatomicRegionDiagnosisProcedure'
                  "
                  :logbookType="statsData.logbookType"
                  :logs="filteredLogs"
                />
                <AnatomicRegionbyGroupTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable ===
                      'anatomicRegionbyGroupTable'
                  "
                  :logbookType="statsData.logbookType"
                  :logs="filteredLogs"
                />
                <SurgeryDiagnoseReport
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable === 'resumeSurgeryDiagnose'
                  "
                  :logbookType="statsData.logbookType"
                  :logs="filteredLogs"
                />
                <OncologyDiagnoseTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable === 'resumeOncologyDiagnose'
                  "
                  :logs="filteredLogs"
                />
                <OncologyClinicalContextTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable ===
                      'resumeOncologyClinicalContext'
                  "
                  :logs="filteredLogs"
                />
                <OncologyMultidisciplinarTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable ===
                      'resumeOncologyMultidisciplinar'
                  "
                  :logs="filteredLogs"
                />
                <OncologyNonProgrammedAppointmentTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable ===
                      'resumeOncologyNonProgrammed'
                  "
                  :logs="filteredLogs"
                />
                <PatologyTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable === 'resumePatology'
                  "
                  :logbookType="statsData.logbookType"
                  :logs="filteredLogs"
                />
                <PatologyByOrganTable
                  v-else-if="
                    statsData.tableType === 'resume' &&
                    statsData.selectedResumeTable ===
                      'resumePathologyByDiagnosisAndOrgan'
                  "
                  :logs="filteredLogs"
                />
              </template>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import specialtyFetcher from '@/mixins/specialtyFetcher'
import { CoordinatedUsers } from '../../models/CoordinatedUsers'
import helpers from './mixins/statsHelperFunc'
import excelHandling from '@/helpers/excel-handling'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import StatisticsHeader from './StatisticsHeader'
import PieChart from './charts/PieChart.vue'
import BarChart from './charts/BarChart.vue'
import Icd10Table from './tables/Icd10Table.vue'
import Icd11Table from './tables/Icd11Table.vue'
import TreeTable from './tables/TreeTable/TreeTable.vue'
import Table2by2 from './tables/Table2by2.vue'
import AutonomyTable from './tables/AutonomyTable.vue'
import AnesthesiaDiagnoseTable from './tables/Anesthesia/AnesthesiaDiagnoseReportTable.vue'
import AnesthesiaCombinedReportTable from './tables/Anesthesia/AnesthesiaCombinedReportTable.vue'
import AnesthesiaAppointmentTable from './tables/Anesthesia/AnesthesiaAppointmentTable.vue'
import SurgeryGeneralReport from './tables/Surgery/SurgeryGeneralReport.vue'
import AnatomicRegionDiagnosisProcedureTable from './tables/Ortopedics/AnatomicRegionDiagnosisProcedureTable.vue'
import AutonomyAndEtiologyBarChart from './tables/Ortopedics/AutonomyAndEtiologyBarChart.vue'
import AnatomicRegionbyGroupTable from './tables/Ortopedics/AnatomicRegionbyGroupTable.vue'
import SurgeryDiagnoseReport from './tables/Surgery/SurgeryDiagnoseReport.vue'
import OncologyDiagnoseTable from './tables/Oncology/OncologyDiagnoseTable.vue'
import OncologyClinicalContextTable from './tables/Oncology/OncologyClinicalContextTable.vue'
import OncologyMultidisciplinarTable from './tables/Oncology/OncologyMultidisciplinarTable.vue'
import OncologyNonProgrammedAppointmentTable from './tables/Oncology/OncologyNonProgrammedAppointmentTable.vue'
import PatologyTable from './tables/PatologyTable.vue'
import PatologyByOrganTable from './tables/PatologyByOrganTable.vue'
import icd10Chapters from '@/content/icd/icd-10-cm-chapters.json'
import icd10Sections from '@/content/icd/icd-10-cm-sections.json'
import domtoimage from 'dom-to-image'
import * as download from 'downloadjs'
import { AgeOption } from '@/models/Content'
import ConditionsTable from './tables/ConditionsTable.vue'
import StatsDashboard from './StatsDashboard.vue'
import resumeTables from './mixins/resumeTables.json'
import { Internship } from '../../models/Specialty'

export default {
  props: {
    interns: { default: false, type: Boolean }
  },
  components: {
    StatisticsHeader,
    PieChart,
    BarChart,
    Icd10Table,
    Icd11Table,
    Table2by2,
    AutonomyAndEtiologyBarChart,
    AnatomicRegionbyGroupTable,
    TreeTable,
    AutonomyTable,
    AnesthesiaDiagnoseTable,
    AnesthesiaCombinedReportTable,
    AnesthesiaAppointmentTable,
    SurgeryGeneralReport,
    AnatomicRegionDiagnosisProcedureTable,
    SurgeryDiagnoseReport,
    OncologyDiagnoseTable,
    OncologyClinicalContextTable,
    OncologyMultidisciplinarTable,
    OncologyNonProgrammedAppointmentTable,
    ConditionsTable,
    StatsDashboard,
    PatologyTable,
    PatologyByOrganTable
  },
  mixins: [specialtyFetcher, helpers],
  data() {
    return {
      coordinatedUser: '',
      fetchingLogs: true,
      statsData: {},
      showStats: false,
      isDownloading: false,
      selectedUsers: [],
      selectedLogbook: null,
      datePeriod: 13,
      selectedSpecialty: this.specialty,
      dateFilter: {
        endDate: new Date(),
        startDate: new Date(moment().subtract(13, 'months'))
      },
      resumeTables: resumeTables
    }
  },
  methods: {
    ...mapActions([
      'getLogs',
      'getLabeledLogs',
      'getCoordinatorLogs',
      'getInternships',
      'getCoodinatorInternships'
    ]),
    changeSpecialty() {
      if (this.selectedSpecialty) {
        return this.fetchSpecialty(this.selectedSpecialty)
      }
    },
    normalizeLogs(logs) {
      const logsCopy = JSON.parse(JSON.stringify(logs))
      return logsCopy.map(l => {
        if (l.age) {
          let numberOfDays = 0
          if (isNaN(l.age)) {
            const amd = l.age.match(/\d+/g)
            if (l.age === '> 90') {
              numberOfDays = 365 * parseInt(amd[0])
            } else {
              numberOfDays =
                365 * parseInt(amd[0]) +
                30 * parseInt(amd[1]) +
                parseInt(amd[2])
            }
          } else {
            numberOfDays = 365 * l.age
          }
          l.age = this.ageOptions.find(
            ao => numberOfDays <= ao.maxValue && numberOfDays >= ao.minValue
          )
          l.age = l.age ? l.age.value : 0
        }

        if (l.durationHours || l.durationMinutes) {
          let numberOfMinutes =
            (l.durationMinutes || 0) + (l.durationHours || 0) * 60
          l.duration =
            this.durationOptions.find(
              ao =>
                numberOfMinutes <= ao.maxValue && numberOfMinutes >= ao.minValue
            )?.value || 'more-than-3-hours'
        }

        l['anesthesia-type'] = []
        // Anesthesia custom component anesthesia-type use keys instead of field values
        if (l['general-anesthesia']) {
          l['anesthesia-type'].push('general')
        }

        if (l['loco-regional-anesthesia']) {
          l['anesthesia-type'].push('loco-regional')
        }

        if (l.sedoanalgesia) {
          l['anesthesia-type'].push('sedoanalgesia')
        }

        if (l.cam) {
          l['anesthesia-type'].push('cam')
        }

        if (l['combined-anesthesia']) {
          l['anesthesia-type'] = ['combined']
        }

        return l
      })
    },
    userStartDate() {
      const start = this.user.residencyStart
      const months = moment.duration(moment(new Date()).diff(start)).asMonths()
      return Math.round(months)
    },
    returnToDash() {
      this.selectedLogbook = null
      this.showStats = false
      this.statsData.logbookType = undefined
    },
    getPaddedHeaders(headers) {
      // console.log(headers)
      // let paddedHeaders = []
      // const span = this.column2Values.length
      // let columnPadding = Math.max(0, span - 1)
      // const padding = new Array(columnPadding).fill('')
      // for (const header of headers) {
      //   if (!['', 'Total'].includes(header)) {
      //     paddedHeaders = [...paddedHeaders, header, ...padding]
      //   }
      // }

      // const prePadding = this.row2Values.length ? ['', ''] : ['']
      // paddedHeaders = [...prePadding, paddedHeaders, 'Total']
      return headers
    },
    exportValues(id) {
      const rows = [...document.querySelectorAll('[id^=' + id + '] table tr')]
      const rowContents = rows.map((row, index) => {
        let cells = [...row.querySelectorAll('th, td')].map(cell => {
          return cell.innerHTML.replace('\n', '').trim()
        })

        if (index === 0) {
          cells = this.getPaddedHeaders(cells)
        }
        return cells.join(';')
      })

      const csv = 'data:text/csv;charset=utf-8,' + rowContents.join('\r\n')

      const uri = encodeURI(csv)

      var link = document.createElement('a')
      link.setAttribute('download', 'statistics-report.csv')
      link.href = uri
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    print(id) {
      this.isDownloading = true
      const node = document.getElementById(id)
      const today = new Date()
      node.style.width = 'fit-content'
      setTimeout(() => {
        domtoimage
          .toJpeg(node, {
            height: node.offsetHeight + 5,
            width: node.offsetWidth
          })
          .then(dataUrl => {
            download(dataUrl, `estatisticas${today.toISOString()}.jpeg`)
            this.isDownloading = false
            node.style.width = '100%'
          })
      }, 2000)
    },
    downloadTable() {
      const table = document.querySelector('table')

      if (!table) {
        return
      }

      const rows = [...table.querySelectorAll('tr')]
      const rowContents = rows.map(row => {
        let cells = [...row.querySelectorAll('th, td')].map(cell => {
          return cell.textContent.replace('\n', '').trim()
        })
        return cells
      })

      const headers = rowContents[0]

      const data = rowContents.slice(1)

      this.isDownloading = true
      excelHandling.createExcel(headers, data).then(blob => {
        this.isDownloading = false
        download(
          blob,
          `xerpa-estatisticas.xlsx`,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )
      })
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'logs',
      'coordinatorLogs',
      'internships',
      'coordinatorInternships',
      'specialty'
    ]),
    specialtyItems() {
      const internships = Internship.query().get()

      const specialties = [
        ...new Set(
          internships
            .filter(
              i =>
                (i.specialtyName &&
                  this.internships.some(item => item.internship === i.id)) ||
                i.specialtyId === this.specialty
            )
            .map(i => {
              return {
                value: i.specialtyId,
                text: i.specialtyName
              }
            })
        )
      ]

      return specialties
    },
    ageOptions() {
      return AgeOption.query().get()
    },
    icdChapters() {
      return icd10Chapters.map(c => ({
        minChapterCode: c.chapter_code.split('-')[0],
        maxChapterCode: c.chapter_code.split('-')[1],
        text: c.chapter_code + ' ' + c.chapter_description,
        value: c.chapter_code
      }))
    },
    icdSections() {
      return icd10Sections.map(c => ({
        minSectionCode: c.section_code.split('-')[0],
        maxSectionCode: c.section_code.split('-')[1],
        text: c.section_code + ' ' + c.section_description,
        value: c.section_code
      }))
    },
    isICD10() {
      if (this.statsData.variables.row1) {
        return (
          this.statsData.variables.row1.type === 'icd10' ||
          this.statsData.variables.row1.type === 'icd10-sec'
        )
      } else {
        return false
      }
    },
    isICD11() {
      if (this.statsData.variables.row1) {
        return this.statsData.variables.row1.type === 'icd11'
      } else {
        return false
      }
    },
    isTreeVars() {
      if (this.statsData.variables.row1) {
        return this.statsData.variables.row1.type === 'multi-select-tree'
      } else {
        return false
      }
    },
    statComponents() {
      if (this.statsData.logbookType) {
        return this.allStatsComponents(this.statsData.logbookType)
      } else {
        return []
      }
    },
    statsTitle() {
      let row1,
        row2,
        column1,
        column2 = ''
      let title = ''
      if (this.statsData && this.statsData.variables) {
        row1 = this.statsData.variables.row1
          ? this.statsData.variables.row1.label
          : null
        row2 = this.statsData.variables.row2
          ? this.statsData.variables.row2.label
          : null
        column1 = this.statsData.variables.column1
          ? this.statsData.variables.column1.label
          : null
        column2 = this.statsData.variables.column2
          ? this.statsData.variables.column2.label
          : null
      }
      if (row1 && row2 && column1 && column2) {
        title = `${row1} por ${row2}, ${column1} e ${column2}`
      }
      if (row1 && row2 && column1 && !column2) {
        title = `${row1} por ${row2}, ${column1}`
      }
      if (row1 && row2 && !column1 && !column2) {
        title = `${row1} por ${row2}`
      }
      if (row1 && !row2 && !column1 && !column2) {
        title = `${row1}`
      }
      if (
        this.statsData.tableType === 'variables' &&
        row1 &&
        column1 &&
        !row2
      ) {
        title = `${row1} por ${column1}`
      }
      return title
    },
    Logs() {
      if (this.interns) {
        const coordinatorLogs = this.coordinatorLogs || []
        return coordinatorLogs ? coordinatorLogs : []
      } else {
        const logs = this.logs || []
        return logs ? logs : []
      }
    },
    filteredLogs() {
      let Logs = this.Logs
      if (this.statsData.logbookType) {
        Logs = Logs.filter(l => l.logbook === this.statsData.logbookType)
      }

      let currentResult = [...Logs]

      if (this.selectedUsers.length && this.interns) {
        const usersId = _.map(this.selectedUsers, 'value')
        return currentResult.filter(l => usersId.includes(l.userId))
      }

      if (this.statsData.selectedSpecialty) {
        currentResult = currentResult.filter(
          l => l.specialty == this.statsData.selectedSpecialty
        )
      }

      if (this.statsData.selectedInternship) {
        currentResult = currentResult.filter(
          l => l.internship == this.statsData.selectedInternship
        )
      }

      currentResult = this.normalizeLogs(currentResult)

      return currentResult
    },
    completeInterships() {
      let internships = []
      if (this.interns === false) {
        internships = this.internships
      } else {
        internships = this.coordinatorInternships
      }
      return internships
    },
    userSpecialties() {
      const componentsCopy = JSON.parse(JSON.stringify(this.statComponents))
      const specialties = componentsCopy.filter(
        component => component.id === 'specialty'
      )
      if (specialties && specialties.length) {
        const filterByLogs = specialties[0].options.filter(specialty =>
          this.logs.some(log => log.specialty === specialty.value)
        )
        return filterByLogs
      }
    },
    coordinatedUsers() {
      const users = _.orderBy(CoordinatedUsers.query().get(), [
        'firstName',
        'lastName'
      ])
      return users.map(i => ({
        text: i.firstName + ' ' + i.lastName,
        value: i.id
      }))
    }
  },
  async created() {
    this.selectedSpecialty = this.specialty
    if (!this.interns) {
      this.getInternships()

      this.fetchSpecialty().then(() => {
        this.getLogs()
          .catch(err =>
            this.showErrorSnackbar(err.message || 'Something went wrong')
          )
          .finally(() => {
            this.getLabeledLogs(this.$store.getters.specialty).then(() => {
              this.fetchingLogs = false
            })
          })
      })
    } else {
      await CoordinatedUsers.fetch(
        this.$store.getters.accessToken,
        this.$store.getters.user.roles,
        this.$store.getters.user.email,
        this.$store.getters.user.hospital,
        this.$store.getters.user.specialty
      ).catch(function (err) {
        return this.$store.dispatch(
          'showErrorSnackbar',
          err.message || 'Something went wrong'
        )
      })
      if (this.coordinatedUsers.length) {
        this.getCoodinatorInternships(this.coordinatedUsers.map(a => a.value))
        this.fetchSpecialty().then(() => {
          this.getCoordinatorLogs(this.coordinatedUsers.map(a => a.value))
            .catch(err =>
              this.showErrorSnackbar(err.message || 'Something went wrong')
            )
            .finally(() => (this.fetchingLogs = false))
        })
      } else {
        this.fetchingLogs = false
      }
    }
  },
  watch: {
    datePeriod(val) {
      if (val) {
        this.dateFilter.endDate = new Date()
        this.dateFilter.startDate = new Date(
          moment().subtract(val, 'months').format()
        )
      }
    },
    selectedLogbook(val) {
      if (val) {
        this.$set(this.statsData, 'logbookType', val)
      }
    },
    coordinatedUser(val, oldVal) {
      if (val !== oldVal) {
        this.fetchingLogs = true

        this.getCoordinatorLogs([val])
          .catch(err =>
            this.showErrorSnackbar(err.message || 'Something went wrong')
          )
          .finally(() => (this.fetchingLogs = false))
      }
    }
  }
}
</script>
<style>
.second-toolbar > .v-toolbar__content {
  padding: 0px 0px;
}
@media only screen and (max-width: 600px) {
  .table-card {
    min-width: initial;
    max-width: 100%;
  }
}

.table-card .v-card__text {
  overflow-x: auto !important;
}
</style>
